module.exports = __webpack_public_path__ + "static/media/female.2b1dcb72.jpg";